import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { store, loadStore } from "store";
import { scanner } from "sensor";
import { reportDevicePosition } from "utils";
var AiAddDevice = /** @class */ (function (_super) {
    tslib_1.__extends(AiAddDevice, _super);
    function AiAddDevice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serial = "";
        _this.loading = false;
        _this.scanStarted = false;
        _this.bluetoothError = null;
        _this.nearbyDeviceCache = {};
        return _this;
    }
    Object.defineProperty(AiAddDevice.prototype, "bluetoothSupported", {
        get: function () {
            return scanner.supported;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AiAddDevice.prototype, "scanning", {
        get: function () {
            return scanner.scanning;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AiAddDevice.prototype, "nearbyDevices", {
        get: function () {
            var _this = this;
            return scanner.sensors.map(function (sensor) {
                var device = _this.nearbyDeviceCache[sensor.serial];
                if (device)
                    return device;
                _this.nearbyDeviceCache[sensor.serial] = device = Vue.observable({
                    serial: sensor.serial,
                    signal: Math.min(Math.max(2 * (sensor.rssi + 100), 0), 100),
                    info: null,
                    infoError: false,
                });
                _this.fillDeviceInfo(sensor.serial, device);
                return device;
            });
        },
        enumerable: true,
        configurable: true
    });
    AiAddDevice.prototype.fillDeviceInfo = function (serial, device) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var info, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        info = store.devices.find(function (d) { return (d.serial || "").toUpperCase() == serial; }) || null;
                        if (info) {
                            device.info = info;
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get("devices/deviceInfo", { params: { serial: serial } })];
                    case 2:
                        info = (_a.sent()).data;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log("deviceInfo error " + JSON.stringify(err_1));
                        info = null;
                        return [3 /*break*/, 4];
                    case 4:
                        if (info) {
                            device.info = info;
                            return [2 /*return*/];
                        }
                        device.infoError = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    AiAddDevice.prototype.destroyed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, scanner.cancelScan()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AiAddDevice.prototype.scan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.scanStarted = true;
                        this.bluetoothError = null;
                        this.nearbyDeviceCache = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, scanner.scan()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        this.bluetoothError = this.$t("error." + err_2.code)
                            || this.$t("error.UNKNOWN_BLUETOOTH") + " " + err_2.code;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AiAddDevice.prototype.addBySerialInput = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var serial;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serial = this.serial.trim().toUpperCase();
                        if (!!serial) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("addDevice.errorSerialRequired") })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.addBySerial(serial)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AiAddDevice.prototype.addBySerial = function (serial) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var existing, data, device;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        existing = store.devices.find(function (d) { return (d.serial || "").toUpperCase() == serial; });
                        if (!existing) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$showDialog({
                                text: this.$t("addDevice.errorSerialExists"),
                                buttons: [
                                    { title: this.$t("common.view"), result: true },
                                    { title: this.$t("common.cancel"), result: false },
                                ],
                            })];
                    case 1:
                        if (_a.sent()) {
                            this.$router.replace("/devices/" + existing.serial);
                        }
                        return [2 /*return*/];
                    case 2:
                        this.loading = true;
                        return [4 /*yield*/, axios.get("devices/deviceInfo", { params: { token: store.sessionToken, serial: serial } })];
                    case 3:
                        data = (_a.sent()).data;
                        this.loading = false;
                        if (!!data) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.$showDialog({ text: this.$t("addDevice.errorSerialNotFound") })];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5:
                        device = data;
                        device.name = device.name || device.serial;
                        store.deviceTemp.push(device);
                        return [4 /*yield*/, loadStore()];
                    case 6:
                        _a.sent();
                        reportDevicePosition(device.serial, "Device");
                        this.$router.replace("devices/" + device.serial);
                        return [2 /*return*/];
                }
            });
        });
    };
    AiAddDevice.prototype.focus = function () {
        this.$refs.input.focus();
    };
    AiAddDevice = tslib_1.__decorate([
        Component
    ], AiAddDevice);
    return AiAddDevice;
}(Vue));
export default AiAddDevice;
